"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMapAppDefaults = void 0;
/* eslint-disable import/prefer-default-export */
const getMapAppDefaults = vp => ({
  mode: 'light',
  map: {},
  panels: {
    layers: {
      title: 'Layers',
      enabled: true,
      toggleable: vp.width === 'compact',
      className: 'app__ui-panel-layers',
      position: {
        pin: 'topright',
        translate: {
          x: -10,
          y: 10
        }
      }
    },
    timeline: {
      title: 'Timeline',
      enabled: true,
      position: {
        pin: vp.width === 'compact' ? 'bottomleft' : 'bottom',
        translate: {
          x: vp.width === 'compact' ? 10 : 0,
          y: -10
        }
      }
    },
    info: {
      enabled: true,
      position: {
        pin: 'topleft',
        translate: {
          x: 10,
          y: 10
        }
      },
      marker: {
        svg: {
          shape: {
            type: 'circle',
            fill: {
              color: '#15a8e1'
            },
            stroke: {
              color: '#ffffff',
              width: 2
            }
          }
        },
        size: [20, 20]
      }
    },
    legends: {
      title: 'Legends',
      enabled: true,
      toggleable: true,
      position: {
        pin: 'bottomright',
        translate: {
          x: -10,
          y: -10
        }
      }
    },
    search: {
      title: 'Location Search',
      enabled: true,
      position: {
        pin: 'top',
        translate: {
          y: 10
        }
      }
    }
  }
});
exports.getMapAppDefaults = getMapAppDefaults;